import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';

import { asAPIError } from 'api/utils/APIError';

import styles from './ErrorFallback.module.scss';

interface ErrorFallbackProps {
  error?: unknown;
  resetErrorBoundary?(...args: Array<unknown>): void;
}

function getErrorDetails(error: unknown): { message: string; requestId?: string } {
  if (error instanceof Error) {
    const apiError = asAPIError(error);
    return { message: error.message, requestId: apiError?.requestId };
  }
  return { message: 'An unexpected error occurred' };
}

/**
 * Error fallback for ErrorBoundary — shows the API error message when available,
 * with a retry button and optional requestId for support correlation.
 */
export default function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  const { message, requestId } = getErrorDetails(error);

  return (
    <div className={styles.errorFallback}>
      <Text as='h1' size='18' fontWeight={7}>
        Something went wrong
      </Text>
      <Text size='14' alignment='center' className={styles.details}>
        {message}
      </Text>
      <Text size='14' alignment='center' className={styles.details}>
        If the problem persists, please contact Lotlinx Operations with an internal ticket (or your
        dedicated Lotlinx Sales or Client Services Representative).
      </Text>
      {requestId && (
        <Text size='12' alignment='center' className={styles.requestId}>
          Reference ID: {requestId}
        </Text>
      )}
      {resetErrorBoundary && (
        <Button variant='outline' onClick={resetErrorBoundary} className={styles.retryButton}>
          Try Again
        </Button>
      )}
    </div>
  );
}
